import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const uploadBulkPodcastApi = createAsyncThunk(
  "podcast-bulk/upload",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AuthAxios.post(apiRoutes.podcastsAction("upload", 1), data, { headers: { "Content-Type": "multipart/form-data" } });

      return response?.data;
    } catch (error) {
      //console.log("error",error);
      return rejectWithValue(error?.response?.data);
    }
  }
);
const intialState = { result: [], loading: false, error: null, message: "" }
const uploadBulkPodcastSlice = createSlice({
  name: "podcast_bulk_upload",
  initialState: { result: [], loading: false, error: null, message: "" },
  reducers: {
    resetImage: () => intialState,
  },
  extraReducers: (builder) => {
    builder.addCase(uploadBulkPodcastApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(uploadBulkPodcastApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result;
      state.message = action?.payload?.message;
    });
    builder.addCase(uploadBulkPodcastApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});
export const { resetImage } = uploadBulkPodcastSlice.actions;
export const uploadBulkPodcastReducer = uploadBulkPodcastSlice.reducer;
